import { render, staticRenderFns } from "./LandingPageCreate.vue?vue&type=template&id=e36d89e8&"
import script from "./LandingPageCreate.vue?vue&type=script&lang=js&"
export * from "./LandingPageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports